import { useState, useCallback } from 'react'

export const useGemini = (apiKey: string) => {
  const [isConfigured, setIsConfigured] = useState(!!apiKey)

  const testApiKey = useCallback(async (apiKey: string): Promise<boolean> => {
    try {
      const response = await fetch('/api/test-gemini', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ apiKey }),
      })

      return response.ok
    } catch (error) {
      console.error('Error testing Gemini API key:', error)
      return false
    }
  }, [])

  return {
    isConfigured,
    testApiKey,
  }
} 